module.exports = __webpack_public_path__ + "fonts/SpareBank1Title-Medium-Web.83db1cc.woff";